import Page, { getProps } from '@/modules/media/press/detail'

export const getServerSideProps = getProps

export default Page
